var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-alert',{staticClass:"mb-2",attrs:{"message":_vm.$t('cloudenv.smal_provider_tips')}}),_c('page-list',{attrs:{"list":_vm.list,"columns":_vm.columns,"group-actions":_vm.groupActions,"single-actions":_vm.singleActions,"export-data-options":_vm.exportDataOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }